var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('audit-list',{attrs:{"audits":_vm.audits,"title":"Assigned Audits / Verifications","subtitle":" ","busy":_vm.isBusy},on:{"updateAudits":_vm.getAudits}})}
var staticRenderFns = []

export { render, staticRenderFns }